<template>
  <div>
    <div style="font-family: DINCond; position: absolute; top: 100px">.</div>
    <div class="canvas page3D" ref="canvas" :class="bgimgnumber == 1?'black':'gray'">
      <div class="loading3d" v-if="loading">{{ loadingNum }}%</div>
    </div>
  </div>
</template>
<script>
  import * as THREE from "../common/three/three.module.js";
  import mobileProxy from "@/common/mobileProxy";

  import {
    OrbitControls
  } from "../common/three/jsm/OrbitControls.js";
  import {
    RGBELoader
  } from "../common/three/jsm/RGBELoader.js";
  import {
    GLTFLoader
  } from "../common/three/jsm/GLTFLoader.js";
  import utils from "../utils.js";
  export default {
    components: {},
    data() {
      return {
        bgimgnumber: 1,
        config: {
          default: {
            gltfSceneScaleSet: {
              x: 1.5,
              y: 1.5,
              z: 1.5,
            },
            controlsTargetSet: {
              x: 0,
              y: 0,
              z: 0,
            },
            cameraPositionSet: {
              x: -5,
              y: 0,
              z: 3.5,
            },
          },
        },
        curConfig: {},
        dataObj: {
          id: "",
          opusattrid: "",
        },
        showVideoBox: false,
        loading: true,
        loadingNum: 0,
        loadingTimer: null,
        isiOS: !!navigator.userAgent.match(/(i[^;]+;( U;)? CPU.+Mac OS X)/),
        isAndroid: navigator.userAgent.indexOf("Android") > -1 ||
          navigator.userAgent.indexOf("Linux") > -1,
        camera: "",
        scene: "",
        renderer: "",
        cubeCamera: "",
        number: "", // 编号
        imgName: "", // 图片名称
        imgUrl: "", // 图片地址
        chartletImg: "", // 贴图img
        chartletImg2: "", // 贴图img
        mapImg: "", // 贴图img
        gltfUrl: "",
        codecolor: "",
        prevTime: 0,
        mixer: null,
        controls: '',
        clips: []
      };
    },
    methods: {
      render() {
        this.renderer.render(this.scene, this.camera);
      },
      animate(time) {
        requestAnimationFrame(this.animate);
        const dt = (time - this.prevTime) / 1000;
        this.controls.update();
        this.mixer && this.mixer.update(dt);
        this.render();
        this.prevTime = time;
      },

      playAllClips() {
        this.clips.forEach((clip) => {
          this.mixer.clipAction(clip).reset().play();
        });
      },
      /**
       * @param {Array<THREE.AnimationClip} clips
       */
      setClips(clips) {
        if (this.mixer) {
          this.mixer.stopAllAction();
          this.mixer.uncacheRoot(this.mixer.getRoot());
          this.mixer = null;
        }
        this.clips = clips;
        if (!clips.length) return;
        this.mixer = new THREE.AnimationMixer(this.content);
      },
      // 创建灯光
      createLight() {
        var ambientLight = new THREE.AmbientLight(0xeeeeee, 0.1);
        this.scene.add(ambientLight);
      },
      // 创建renderer
      createRenderer() {
        this.renderer = new THREE.WebGLRenderer({
          antialias: true,
          alpha: true,
        });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, this.$refs.canvas.offsetHeight);
        this.camera.aspect = window.innerWidth / this.$refs.canvas.offsetHeight;
        this.renderer.toneMapping = THREE.LinearToneMapping;
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        this.renderer.shadowMapEnabled = true;
        //按层级进行先后渲染
        this.renderer.sortObjects = true;
      },
      // 创建相机
      createCamera() {
        //设置透明物体的渲染层级（默认是0）
        // this.camera = new THREE.PerspectiveCamera(45, window.innerWidth / this.$refs.canvas.offsetHeight, 1, 2000)
        this.camera = new THREE.PerspectiveCamera(45, window.innerWidth / this.$refs.canvas.offsetHeight, 0.25, 20);
        this.camera.position.set(this.curConfig.cameraPositionSet.x, this.curConfig.cameraPositionSet.y, this.curConfig
          .cameraPositionSet.z);
        this.scene = new THREE.Scene();
        this.cubeCamera = new THREE.CubeCamera(0.1, 1000, 256);
        this.scene.add(this.cubeCamera);
      },
      init() {
        this.curConfig = Object.assign(this.curConfig, this.config.default);
        this.scene = new THREE.Scene()
        // this.camera.position.set(6, 4, -9)
        // this.camera.lookAt(new THREE.Vector3(0, 0, 0))

        this.createCamera();
        this.createLight();
        this.createRenderer();

        this.controls = new OrbitControls(this.camera, this.renderer.domElement)
        this.controls.target.set(0, 0, 0)
        // this.controls.maxDistance = 9
        // this.controls.minDistance = 0.1
        this.controls.enableZoom = false;
        // this.controls.rotateSpeed = 3; //旋转的速度，其默认值为1.
        // this.controls.autoRotate = true;
        this.controls.mouseButtons = {
          //这一对象包含了对用于控制的鼠标按钮的引用。
          // LEFT: THREE.MOUSE.ROTATE,
          // MIDDLE: THREE.MOUSE.DOLLY,
          // RIGHT: THREE.MOUSE.PAN
        };
        this.controls.touches = {
          //This object contains references to the touch actions used by the controls.
          // ONE: THREE.TOUCH.ROTATE,
          // TWO: THREE.TOUCH.DOLLY_ROTATE,
        };
        this.controls.update()
        this.controls.addEventListener("change", render);
        var that = this;

        function render() {
          that.renderer.render(that.scene, that.camera);
        }

        new RGBELoader().setPath("../../../static/gltf/").load("Sky.hdr", (texture) => {
          texture.mapping = THREE.EquirectangularReflectionMapping;
          this.scene.background = "";
          this.scene.environment = texture;
          const loader = new GLTFLoader().setPath("");
          // const loader = new GLTFLoader().setPath('../../../static/gltf/');
          this.animate = this.animate.bind(this);
          requestAnimationFrame(this.animate);
          loader.load(this.gltfUrl,
            gltf => {
              // gltf.scene.translateY(1.8)
              gltf.scene.scale.set(
                this.curConfig.gltfSceneScaleSet.x,
                this.curConfig.gltfSceneScaleSet.y,
                this.curConfig.gltfSceneScaleSet.z
              );

              var group = new THREE.Group();
              var selectedObject;
              gltf.scene.traverse(function (obj) {
                if (obj.name === 'BianHuang') {
                  selectedObject = obj;
                  obj.geometry.dispose();
                  obj.material.dispose();
                }
              })
              group.add(selectedObject)
              this.scene.remove(group);


              this.scene.add(gltf.scene)
              console.log(gltf.scene)
              // 调用动画
              const scene = gltf.scene || gltf.scenes[0];
              const clips = gltf.animations || [];
              this.content = scene;

              this.setClips(clips);
              this.playAllClips();

              // const sceneBox = new THREE.Box3().setFromObject(this.scene);
              // var center = new THREE.Vector3();
              // sceneBox.getCenter(center);
              // this.camera.lookAt(center);
              // this.camera.updateProjectionMatrix();
              // this.controls.target.set(center.x, center.y, center.z);

              this.loading = false;
            },
            (item, loaded, total) => {
              var contentLength;
              var loaded = item.loaded;
              if (item.lengthComputable) {
                contentLength = item.total;
              } else {
                contentLength = item.target.getAllResponseHeaders();
              }
              var percent = ((loaded / contentLength) * 100).toFixed(0);

              this.loadingNum = percent;
              // if (percent >= 100) {
              this.$refs.canvas.appendChild(this.renderer.domElement);
              // }
            }
          )
        });



      },
      // 查询模型
      queryGltflist() {
        this.$fetchql
          .japiFetch("post", "appapi/unitymodel/prop/info", {
            opusid: this.$route.query.id - 0,
            opusattrid: this.$route.query.opusattrid - 0,
          })
          .then((res) => {
            try {
              this.bgimgnumber = res.data.bgimgnumber;
              this.curConfig = Object.assign(this.curConfig, this.config.default);
              if (res.data.type == 1) {
                this.gltfUrl = res.data.modelurl;
                if (!this.gltfUrl) {
                  this.showErrorAndBack();
                  return;
                }
                this.imgUrl = res.data.coverimgurl;
                this.codecolor = res.data.codecolor || '#1ce89e';
                // this.gltfUrl = 'flyer.gltf'
              } else {
                // this.gltfUrl = 'flyer_.gltf'
                // this.gltfUrl = 'flyer.gltf'
              }
              this.init();
            } catch (err) {
              this.showErrorAndBack();
            }
          });
      },
      showErrorAndBack() {
        // this.$toast({
        //   message: "网络异常，请稍后再试！",
        //   duration: 1500,
        // });
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      },
    },

    mounted() {
      console.log(new Blob())
      this.queryGltflist()
    },
    activated() {
      console.log(new Blob())
    },
  };

</script>
<style lang="less" scoped>
  @font-face {
    font-family: "DINCond";
    src: url("../../static/fonts/DINCond-Medium.otf");
  }

  .canvas {
    position: relative;
    width: 100%;
    height: 418px;

    &.black {
      background: url("/static/gltf/bg/1bg.png") center center;
    }

    &.gray {
      background: url("/static/gltf/bg/2bg.png")center center;
    }

    // background: radial-gradient(ellipse, #FFFFFF 0%, #E7E7E7 35%, #868686 100%);
    background-size: 100% 418px;

    .loading3d {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -42px;
      margin-top: -15px;
      width: 84px;
      height: 30px;
      border-radius: 15px;
      background: url("../../static/gltf/bg/loading.png") no-repeat 10px center rgba(255, 255, 255, 0.5);
      background-size: 23px 23px;
      line-height: 30px;
      box-sizing: border-box;
      font-weight: 500;
      color: #000000;
      font-size: 13px;
      text-indent: 40px;
      pointer-events: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/detail3DAnimate.vue